import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AnnouncementSubscriptionRequest } from '../models/announcement-subscription-request';
import { AnnouncementSubscription } from '../models/AnnouncementSubscription';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { AnnouncementsService } from '../services/announcements.service';
import { MatTabGroup } from '@angular/material/tabs';

@Component({
    selector: 'app-announcement-subscription-dialog',
    templateUrl: './announcement-subscription-dialog.component.html',
    styleUrl: './announcement-subscription-dialog.component.css',
    standalone: false
})
export class AnnouncementSubscriptionDialogComponent {
  subscriptionEmail = '';
  announcementTypes: string[] = [];
  selectedTypes: string[] = [];
  isEmailValid: boolean = false;
  subscriptions: any;
  displayedColumns: string[] = ['email', 'addedAnnouncementTypes', 'action'];
  announcementService: AnnouncementsService;
  @ViewChild('subscriptionsTable') subscriptionsTable!: MatTable<any>;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  @ViewChild('tabGroup') tabGroup!: MatTabGroup;

  constructor(
    public dialogRef: MatDialogRef<AnnouncementSubscriptionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.announcementTypes = data.announcementTypes;
    this.subscriptions = new MatTableDataSource<AnnouncementSubscription>(data.subscriptions);
    this.announcementService = data.announcementService;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  subscribe(): any {
    const subscription : AnnouncementSubscriptionRequest = {
      SubscriberEmail: this.subscriptionEmail,
      AddedAnnouncementTypes: this.selectedTypes,
      IgnoredAnnouncementTypes: this.announcementTypes.filter(t => !this.selectedTypes.includes(t))
    };
    this.dialogRef.close(subscription);
  }

  deleteSubscription(subscription: AnnouncementSubscription): void {
    this.subscriptions.data = this.subscriptions.data.filter((s: AnnouncementSubscription) => s.subscriberEmail !== subscription.subscriberEmail);
    this.announcementService.deleteSubscription(subscription.subscriberEmail).subscribe();
  }

  editSubscription(subscription: AnnouncementSubscription): void {
    this.subscriptionEmail = subscription.subscriberEmail;
    this.selectedTypes = subscription.addedAnnouncementTypes;
    this.validateEmail(this.subscriptionEmail);
    this.tabGroup.selectedIndex = 0;
  }

  validateEmail(email: string): void {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    this.isEmailValid = emailPattern.test(email);
  }
}
